import { Popover, Checkbox, Button } from 'antd'
import { SettingOutlined } from '@ant-design/icons'

export interface ColumnConfig {
  key: string
  label: string
}

interface ColumnSelectorProps {
  allColumns: ColumnConfig[]
  visibleColumns: string[]
  onChange: (columns: string[]) => void
}

export default function ColumnSelector({ allColumns, visibleColumns, onChange }: ColumnSelectorProps) {
  const content = (
    <div style={{ minWidth: 180 }}>
      {allColumns.map((col) => (
        <div key={col.key} style={{ padding: '4px 0' }}>
          <Checkbox
            checked={visibleColumns.includes(col.key)}
            onChange={(e) => {
              if (e.target.checked) {
                onChange([...visibleColumns, col.key])
              } else {
                onChange(visibleColumns.filter((k) => k !== col.key))
              }
            }}
          >
            {col.label}
          </Checkbox>
        </div>
      ))}
    </div>
  )

  return (
    <Popover content={content} trigger="click" placement="bottomRight" title="Columns">
      <Button icon={<SettingOutlined />} style={{ borderRadius: 8 }}>
        Columns
      </Button>
    </Popover>
  )
}
